exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".my-account-nav {\n  text-align: center;\n  margin: 0 auto;\n}\n.my-account-nav a {\n  color: #666667;\n  padding: 10px;\n  min-width: 150px;\n}\n.my-account-nav a:hover,\n.my-account-nav a.active {\n  background: #f5f5f5;\n}\n", ""]);

